import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const ViewGenAiPrompt = Loadable(
  lazy(() =>
    import("./genAiPrompt/genAiPrompt").then(({ ViewGenAiPrompt }) => ({
      default: ViewGenAiPrompt,
    }))
  )
);
const ViewGenAiContext = Loadable(
  lazy(() =>
    import("./genAiContext/genAiContext").then(({ ViewGenAiContext }) => ({
      default: ViewGenAiContext,
    }))
  )
);
const ManageGenAiPrompt = Loadable(
  lazy(() =>
    import("./genAiPrompt/managegenAiPrompt").then(({ ManageGenAiPrompt }) => ({
      default: ManageGenAiPrompt,
    }))
  )
);
const ManageGenAiContext = Loadable(
  lazy(() =>
    import("./genAiContext/managegenAiContext").then(
      ({ ManageGenAiContext }) => ({
        default: ManageGenAiContext,
      })
    )
  )
);

export const genAiRoutes = [
  {
    path: "/gen-ai-prompt",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.GENAI_PROMPT]}>
        <ViewGenAiPrompt />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/gen-ai-prompt/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.GENAI_PROMPT]}>
        <ManageGenAiPrompt />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/gen-ai-prompt/manage/:genAiPromptId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.GENAI_PROMPT]}>
        <ManageGenAiPrompt />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/gen-ai-context",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.GENAI_CONTEXT]}>
        <ViewGenAiContext />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/gen-ai-context/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.GENAI_CONTEXT]}>
        <ManageGenAiContext />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/gen-ai-context/manage/:genAiContextId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.GENAI_CONTEXT]}>
        <ManageGenAiContext />
      </AuthorizedRoute>
    ),
  },
];
